import React from 'react';
import {injectIntl} from 'react-intl';
import {connect} from 'react-redux';
import {getCustomTag} from '../reducers/custom-material';
import backdropTags from '../lib/libraries/backdrop-tags';
import messages from '../lib/libraries/tag-messages.js';

const LibraryBackdropHOC = WrappedComponent => {
    class LibraryBackdropComponent extends React.Component {
        constructor(props) {
            super(props);
        }
        componentDidMount() {
            if (!Array.isArray(this.props.customTags)) {
                this.props.getCustomTag();
            }
        }

        render() {
            const {
                customBackdrop,
                customTags,
                ...componentProps
            } = this.props;

            let customData = []

            if (Array.isArray(customBackdrop)) {
                let data = customBackdrop.map(item => {
                    return {...item, info: (typeof item.info === 'string') ? item.info.split(',') : item.info}
                });

                customData = data;
            }

            let finalTags = [];

            if (Array.isArray(customTags)) {
                finalTags = [...(customTags.map(tag => ({
                    tag: tag.replace(/\s/g, '_'), intlLabel: messages[tag.replace(/\s/g, '_')]
                }))), ...backdropTags];
            } else {
                finalTags = [...backdropTags];
            }

            return (
                <WrappedComponent
                    data={customData}
                    tags={finalTags}
                    {...componentProps}
                />
            )
        }
    }

    const mapStateToProps = state => ({
        customBackdrop: state.scratchGui.customMaterial.customBackdrop,
        customTags: state.scratchGui.customMaterial.tags
    });
    const mapDispatchToProps = dispatch => ({
        getCustomTag: () => dispatch(getCustomTag())
    });

    return injectIntl(connect(
        mapStateToProps,
        mapDispatchToProps
    )(LibraryBackdropComponent));
};

export {
    LibraryBackdropHOC as default
}
